import { render } from "./repairing.vue?vue&type=template&id=45283014"
import script from "./repairing.vue?vue&type=script&lang=js"
export * from "./repairing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__